import { selector } from 'recoil';
import { aCurrentRoomId } from 'shared-state/location/atoms';
import { aIdentityClaims } from 'shared-state/identity/atoms';
import { sUsersInRoom } from 'shared-state/presence/selectors';
import { IWidget } from '../components/Widgets/type';
import { aBottomImageIndex, aTopImageIndex, aWidgetsList } from './atoms';

export const sIsUserAloneInOwnPersonalRoom = selector<boolean>({
    key: 'sIsUserAloneInOwnPersonalRoom',
    get: ({ get }) => {
        const currentRoomId = get(aCurrentRoomId);
        const idClaims = get(aIdentityClaims);
        if (!currentRoomId || !idClaims) return false;

        const allUsersIncludingLocalUsers = get(sUsersInRoom(currentRoomId));
        const isPersonalRoom = currentRoomId.includes('personal-');
        const isUserInPersonalRoom = currentRoomId.includes(idClaims.uid);
        const isUserAloneInPersonalRoom = allUsersIncludingLocalUsers.length < 2;

        return isPersonalRoom && isUserInPersonalRoom && isUserAloneInPersonalRoom;
    }
});

export const sMeetingCornerSetting = selector<{ widgets: IWidget[]; topImageIndex: number; bottomImageIndex: number }>({
    key: 'sMeetingCornerSetting',
    get: ({ get }) => {
        const widgetsList = get(aWidgetsList);
        const topImageIndex = get(aTopImageIndex);
        const bottomImageIndex = get(aBottomImageIndex);
        return { widgets: widgetsList, topImageIndex, bottomImageIndex };
    }
});
